import BlokWrap from "@/components/ui/BlokWrap";
import { RichTextRender } from "@/components/ui/RichText";
import { ContentStoryblok } from "@/generated/sb/sb-types";
import { BlokProps } from "@frend-digital/storyblok";
import clsx from "clsx";
import styles from "./index.module.css";

export const Content = ({
  blok,
  preview,
  column,
}: BlokProps<ContentStoryblok> & {
  column?: boolean;
}) => {
  return (
    <BlokWrap animated="fadeY" editorial editable={blok}>
      <div
        className={clsx(styles.wrapper, column && styles.column)}
        data-layout="page"
      >
        <div className={styles.inner}>
          {blok.text && <RichTextRender blok={blok.text} preview={preview} />}
        </div>
      </div>
    </BlokWrap>
  );
};
